import { StringMap } from '@app/utils/string-map';

export class Translation {
  get entries(): [string, string][] {
    return Object.entries(this.translations);
  }

  get overwrittenEntries(): [string, string][] {
    return Object.entries(this.overrides);
  }

  get overwritten(): boolean {
    return Object.keys(this.translations).reduce((alreadyOverwritten, language) => {
      const hasOverride = this.overrides[language] != null;

      return alreadyOverwritten || hasOverride;
    }, false);
  }

  constructor(
    public key: string,
    public translations: StringMap<string> = {},
    public overrides: StringMap<string> = {}
  ) {}
}
